import React from 'react';

import Heading from '@atlaskit/heading';

import type { ColorMode } from '../../types';
import ButtonGroup from '../button-group';

type ColorModeProps = {
	colorMode: ColorMode;
	onColorModeChange?(theme: ColorMode): void;
	testId?: string;
};

/**
 * __Color mode section__
 *
 * A form section allows users to select the color mode for examples.
 */
const ColorModeSection = ({
	colorMode,
	onColorModeChange,
	testId,
}: ColorModeProps): React.JSX.Element => {
	return (
		<>
			<Heading size="xsmall" as="h2" id="color-mode">
				Color mode
			</Heading>
			<ButtonGroup
				options={[
					{ value: 'light', label: 'Light' },
					{ value: 'dark', label: 'Dark' },
					{ value: 'auto', label: 'Match browser' },
				]}
				selected={colorMode}
				onChange={onColorModeChange}
				testId={testId ? `${testId}--color-mode` : undefined}
				labelId="color-mode"
			/>
		</>
	);
};

export default ColorModeSection;
